// Componente Persona.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-container fluid="xl">
          <b-row class="my-1">
            <b-col>Código:</b-col>
            <b-col>Rut:</b-col>
            <b-col>Nombre:</b-col>
            <b-col>Nación:</b-col>
          </b-row>
           <b-row class="my-1">
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.codigo"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.rut"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.nombre"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.nacion"></b-input> </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col>Contacto:</b-col>
            <b-col>Dirección:</b-col>
            <b-col>Ciudad:</b-col>
            <b-col>Comuna:</b-col>
          </b-row>
           <b-row class="my-1">
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.contacto"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.direccion"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.ciudad"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.comuna"></b-input> </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col>Email:</b-col>
            <b-col>Fono/Fax/Comen:</b-col>
            <b-col>Ingreso:</b-col>
            <b-col>Modificación:</b-col>
          </b-row>
           <b-row class="my-1">
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.email"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.fonofax"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.ingreso"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.modificacion"></b-input> </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col>Tipo:</b-col>
            <b-col>Dirección Postal:</b-col>
            <b-col>Ciudad Postal:</b-col>
            <b-col>Comuna Postal:</b-col>
          </b-row>
           <b-row class="my-1">
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.tipo"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.dirpostal"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.ciupostal"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.compostal"></b-input> </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col>Ejecutivo:</b-col>
            <b-col>Corredor:</b-col>
            <b-col>Facturador:</b-col>
            <b-col></b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.cliente"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.escorredor"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"><b-input size="sm" disabled v-model="datosFormulario.esfacturador"></b-input> </b-col>
            <b-col sm = "1"></b-col>
            <b-col sm = "2"></b-col>
          </b-row>
        </b-container>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

    <b-modal
      size="lg"
      scrollable
      hide-footer
      title="Facturador"
      cancel-title="Cancelar"
      v-model="modalFacturador"
      @cancel="modalFacturador = false"
    >
      <b-col lg="12">
        <b-container fluid="xl">
          <b-row>
            <p> Persona {{this.datosFormulario.esfacturador}} es Facturador</p>
          </b-row>
        </b-container>
      </b-col>  
    </b-modal>

    <b-modal
      size="lg"
      scrollable
      hide-footer
      title="Corredor"
      cancel-title="Cancelar"
      v-model="modalCorredor"
      @cancel="modalCorredor = false"
    >
      <b-col lg="12">
        <b-container fluid="xl">
          <b-row>
            <p> Persona  abc falta esa informacion es Corredor</p>
          </b-row>
        </b-container>
      </b-col>  
    </b-modal>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Persona",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    // title: { type: String },
    cod_asegurado: Number,
    // timeOnSite: { type: Number, required: true }
  },

  data: function() {
    return {
      datapersona:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modalFacturador: false,
      modalCorredor: false,
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },
      
      
      titles: [
        {
          prop: "codigo",
          label: "Código",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "rut",
          label: "Rut",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "nombre",
          label: "Nombre",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "nacion",
          label: "Nación",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "contacto",
          label: "Contacto",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "direccion",
          label: "Dirección",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "ciudad",
          label: "Ciudad",
          align: "left",
          minwidth:'100'
        },      
        {
          prop: "email",
          label: "Email",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "fonofax",
          label: "Fono Fax",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "ingreso",
          label: "Fecha Ingreso",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "modificacion",
          label: "Fecha Modificación",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "tipo",
          label: "Tipo",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "dirpostal",
          label: "Dirección Postal",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "ciupostal",
          label: "Cuidad Postal",
          align: "left",
          minwidth:'120'
        },      
        {
          prop: "compostal",
          label: "Comuna Postal",
          align: "left",
          minwidth:'120'
        },      
        {
          prop: "esfacturador",
          label: "Facturador",
          align: "center",
          minwidth:'100'
        }
        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormulario: {
        codigo: "",
        rut: "",
        nombre: "",
        nacion: "",
        contacto: "",
        direccion: "",
        ciudad: "",
        comuna: "",
        email: "",
        fonofax: "",
        ingreso: "",
        modificacion: "",
        tipo: "",
        dirpostal: "",
        ciupostal: "",
        compostal: "",
        cliente: "",
        esfacturador: "",
        escorredor: ""
      },

    }
  },
  methods: {

        formatter(row, column) {
          if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
        },

        recuperar_persona() {
            this.$Progress.start(); 
            console.log(this.cod_asegurado);
            return apiConsultaCliente
              .recuperar_persona(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.cod_asegurado
              )  
              .then(response => {
                
                response.data = this.keysMinuscula(response.data);
                var datapersona = response.data.res;
                for (var i = 0; i < datapersona.length; i++) {
                  this.datosFormulario.codigo = datapersona[i]["codigo"];
                  this.datosFormulario.rut = datapersona[i]["rut"];
                  this.datosFormulario.nombre = datapersona[i]["nombre"];
                  this.datosFormulario.nacion = datapersona[i]["nacion"];
                  this.datosFormulario.contacto = datapersona[i]["contacto"];
                  this.datosFormulario.direccion = datapersona[i]["direccion"];
                  this.datosFormulario.ciudad = datapersona[i]["ciudad"];
                  this.datosFormulario.comuna = datapersona[i]["comuna"];
                  this.datosFormulario.email = datapersona[i]["email"];
                  this.datosFormulario.fonofax = datapersona[i]["fonofax"];
                  this.datosFormulario.ingreso = datapersona[i]["ingreso"];
                  this.datosFormulario.modificacion = datapersona[i]["modificacion"];
                  this.datosFormulario.tipo = datapersona[i]["tipo"];
                  this.datosFormulario.dirpostal = datapersona[i]["dirpostal"];
                  this.datosFormulario.ciupostal = datapersona[i]["ciupostal"];
                  this.datosFormulario.compostal = datapersona[i]["compostal"];
                  this.datosFormulario.cliente = datapersona[i]["cliente"];
                  this.datosFormulario.esfacturador = datapersona[i]["esfacturador"];
                  this.datosFormulario.escorredor = datapersona[i]["escorredor"];
                  

                }
                
                this.$Progress.finish();
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
          },

       

        
  },
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_persona();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>